import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';

const ProfileExperience = ({
  experience: { company, title, location, current, to, from, description }
}) => (
  <div className="credential">
    <div className="card-body">
      <h6 className="">
        <i className="fas fa-briefcase"></i> {title}
      </h6>
      <span className="location"> &#8226; {location}</span>

      <p className="company">{company}</p>

      <p className="years">
        {' '}
        <Moment format="MMM YYYY">{moment.utc(from)}</Moment> -{' '}
        {to === null ? (
          ' Now'
        ) : (
          <Moment format="MMM YYYY">{moment.utc(to)}</Moment>
        )}
      </p>
    </div>
  </div>
);

ProfileExperience.propTypes = {
  experience: PropTypes.object.isRequired
};

export default ProfileExperience;
